import { useEffect, useRef } from 'react';
import * as Tableau from 'tableau-api-js';
import { TABLEAU_DISPLAY_NAME } from '../constants/tableauConstants';

const TableauMap = ({ country }) => {
  const tableauContainerRef = useRef<HTMLDivElement>();
  let viz = useRef<any>();
  const url =
    'https://tableau.apps.fao.org/views/AgriTO20-1-2026/subpage_map';

  useEffect(() => {
    const options = {
      hideTabs: true,
      hideToolbar: true,
      [TABLEAU_DISPLAY_NAME.COUNTRY_OR_TERRITORY]: country,
      height: 300,
      width: '100%',
    };
    viz.current = new Tableau.Viz(
      tableauContainerRef.current,
      url,
      options
    );
  }, [country]);

  return <div ref={tableauContainerRef} />;
};

export default TableauMap;
